import React from 'react'
import "./commoncss.css";

const Loader = ({
  size = "70px",
  ballSize = "14px",
  color = "#ffffff",
  trackColor = "rgba(255,255,255,0.15)",
}) => {
  return (
    <>
      <div
        className="orbit-spinner"
        style={{
          width: size,
          height: size,
          borderColor: trackColor,
        }}
      >
        <div
          className="orbit-ball"
          style={{
            width: ballSize,
            height: ballSize,
            background: color,
          }}
        ></div>
      </div>

      <style>
        {`
          .orbit-spinner {
            position: relative;
            border-radius: 50%;
            border: 3px solid;
            animation: rotateOrbit 1s linear infinite;
          }

          .orbit-ball {
            position: absolute;
            top: -7px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50%;
            box-shadow: 0 4px 10px rgba(0,0,0,0.25);
          }

          @keyframes rotateOrbit {
            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </>
  );
};

export const ComponentLoader = ({ color = "#3b82f6", size = "24px", padding = "10px" }) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      width: '100%', 
      height: '100%',
      padding: padding
    }}>
      <i className="fa fa-spinner fa-spin" style={{ color: color, fontSize: size }}></i>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;

